export default {
  affectedRoleData: ({ affectedRoleData }) => affectedRoleData || null,

}
